
export const myMenuItems = {
  data() {
    return {
      // 添加新节点列表
      addNewObjectMenuList: [
        { name: '新增节点', icon: 'fa-hdd-o', fun: this.addNode },
        { name: '新增实网', icon: 'fa-cloud', fun: this.addNetwork },
        // { name: '新增图片', icon: 'fa-file-picture-o', fun: this.add },
        // { name: '新增图形', icon: 'fa-square-o', fun: this.add },
        // { name: '新增文本', icon: 'fa-font', fun: this.add }
      ],
      autoAlign: [{ name: '自动布局', icon: 'fa-th', fun: this.autoLayout }],
      nodeMenuList: [
        { name: '开机', icon: 'fa-play-circle-o', fun:this.begin },
        { name: '关机', icon: 'fa-stop-circle-o', fun:this.stop },
        { name: '断电', icon: 'fa-plug', fun: this.interrupt},
        { name: '恢复', icon: 'fa-hourglass-half', fun: this.recovery },
        { name: '重启', icon: 'fa-circle-o-notch', fun: this.reboot },
        { name: '暂停', icon: 'fa-hourglass', fun: this.suspend },
        // { name: '发送指令', icon: 'fa-code', fun: this.sendInstruction },
        '分割线',
        { name: '编辑', icon: 'fa-cog', fun: this.compiler },
        { name: '删除', icon: 'fa-trash-o', fun: this.strikeout },
        // { name: '清除', icon: 'fa-eraser', fun: this.add },
        // { name: '导出配置文件', icon: 'fa-download', fun: this.add }
      ],
      captureList: [
        // { name: '捕获', icon: 'fa-chevron-right', fun: this.add }
      ],
      editAndDelList: [
        // { name: '编辑', icon: 'fa-pencil-square-o', fun: this.edit },
        { name: '删除', icon: 'fa-trash-o', fun: this.deletCloud }
      ],
      // 框选节点时的菜单
      setectedMenuList: [
        { name: '开启所选设备', icon: 'fa-play-circle-o', fun: this.edit },
        { name: '关闭所选设备', icon: 'fa-stop-circle-o', fun: this.edit },
        { name: '清除所选设备', icon: 'fa-eraser', fun: this.edit },
        { name: '开启设备控制台', icon: 'fa-window-maximize', fun: this.edit },
        '分割线',
        { name: '导出所有配置', icon: 'fa-download', fun: this.edit },
        { name: '导出启动配置', icon: 'fa-share-square-o', fun: this.edit },
        { name: '清空启动配置', icon: 'fa-spinner', fun: this.edit },
        '分割线',
        { name: '删除启动配置', icon: 'fa-trash-o', fun: this.edit },
        { name: '删除所选节点', icon: 'fa-trash-o', fun: this.edit },
        '分割线',
        { name: '水平对齐', icon: 'fa-pause',fun: this.level },
        { name: '垂直对齐', icon: 'fa-eject',fun: this.vertical },
        // { name: '圆形对齐', icon: 'fa-eercast',  },
      ],
      // 线段右键菜单
      edgeCloudmenu: [{ name: '删除云端连线', icon: 'fa-trash-o', fun:this.deletCloudLine }],
      edgeContextmenu: [{ name: '删除连线', icon: 'fa-trash-o', fun: this.delEdge }],
      
    }
  }
}
